module.exports = __webpack_public_path__ + "static/img/marcus_pictgrid58_1080x859.b2f31f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/marcus_pictgrid58_1080x859.jpg
// module id = 6ehB
// module chunks = 0